// PlaceDetails.js
import React from "react";
import { useTranslation } from "react-i18next";
import "./PlaceDetails.css";
import MapComponent from "../Map";

const PlaceDetails = ({
  type = "Hotel",
  size = "444.4",
  capacity = "200",
  rooms = "250",
  brand = "Crowne Plaza Hotels",
  build = "2011",
  amenities = [],
  latitude,
  longitude,
}) => {
  const { t, i18n } = useTranslation("place");

  return (
    <div className="place-details">
      <h3>{t("PlaceDetails.overview")}</h3>

      <div className="place-details-content">
        <div className="content-first-row">
          <div className="place-column">
            <div className="type">
              <p className="head">{t("PlaceDetails.venueType")}</p>
              <p className="value">
                {(i18n.language === "ar" && type.title_ar ? type.title_ar : type.title)}
              </p>
            </div>
            <div className="type">
              <p className="head">{t("PlaceDetails.meetingSpace")}</p>
              <p className="value">
                {size} {t("PlaceDetails.meetingSpaceUnit")}
              </p>
            </div>
          </div>

          <div className="place-column">
            <div className="type">
              <p className="head">{t("PlaceDetails.capacity")}</p>
              <p className="value">{capacity}</p>
            </div>
            <div className="type">
              <p className="head">{t("PlaceDetails.guestRooms")}</p>
              <p className="value">{rooms}</p>
            </div>
          </div>
        </div>

        <div className="content-first-row">
          <div className="place-column">
            <div className="type">
              <p className="head">{t("PlaceDetails.brand")}</p>
              <p className="value">{brand}</p>
            </div>
            <div className="type">
              <p className="head build">{t("PlaceDetails.build")}</p>
              <p className="value build" style={{ paddingRight: "65px" }}>
                {build}
              </p>
            </div>
          </div>

          <div className="place-column">
            <div className="dummy" />
            <div className="dummy" />
          </div>
        </div>
      </div>

      <h3>{t("PlaceDetails.amenities")}</h3>
      <div className="amenities">
        {amenities.map((item, index) => {
          const label = i18n.language === "ar" && item.name_ar ? item.name_ar : item.name;
          return (
            <div
              className="amenities-type"
              key={item.id != null ? item.id : index}
              style={(index + 1) % 4 === 0 ? { textAlign: "right" } : {}}
            >
              <p>{label}</p>
            </div>
          );
        })}
      </div>

      <h3 style={{ marginTop: "20px" }}>{t("PlaceDetails.location")}</h3>
      <div className="map">
        <MapComponent center={{ lat: latitude, lng: longitude }} fixed={true} />
      </div>
    </div>
  );
};

export default PlaceDetails;
